//
function Context() {
    var self = this;
    //
    var deferred = $.Deferred();
    //
    var handlers = [];
    // 修改改视图模型为 会员跟踪
    this.markMemberAware = function (handler) {
        if ($.isFunction(handler)) {
            handlers.push(handler)
            deferred.done(handler)
        }
    };
    //
    this.resolveForcefully = function (member) {
        self.member = member;
        if (deferred.state() === 'pending') {
            deferred.resolve(member);
        } else {
            $.each(handlers, function () {
                this(member);
            });
        }
    };

    //
    var cartDeferred = $.Deferred();
    var cartHandlers = [];
    this.markCartAware = function (handler) {
        if ($.isFunction(handler)) {
            cartHandlers.push(handler);
            cartDeferred.done(handler);
        }
    };
    this.resolveCartsForcefully = function (carts) {
        if (cartDeferred.state() === 'pending') {
            cartDeferred.resolve(carts);
        } else {
            $.each(cartHandlers, function () {
                this(carts);
            });
        }
    }

    //
    function __init() {
        return $.get(hostsetter('members/current')).success(function (member) {
            self.member = member;
            if (member.id) {
                self.resolveForcefully(member);
            }
        })
    }

    this.jumpToLoginIfNoMember = function () {
        if (!self.member) {
            __init().success(function () {
                console.log(self.member)
                if (!self.member || !self.member.id) {
                    console.log(window.location.href)
                    if (window.location.href.indexOf('/forget.html') == -1){
                        window.location.href = '/login.html?action=login';
                    }
                }
            })
        }
    }

    //
    var logining = false;
    //
    this.memberOrLogin = function (callback) {
        if (!self.member) {
            __init().success(internalCallback)
        } else {
            internalCallback(self.member)
        }

        //
        function internalCallback(member) {
            if (!member.id) { // 如果未登录
                // 弹框登录
                if (logining === false) {
                    logining = true;
                    $.get({
                        url: '/partial/login.html',
                        contentType: 'text/html',
                        loading: false
                    }).success(function (res) {
                        layer.open({
                            type: 1,
                            title: '',
                            closeBtn: false,
                            area: ['auto', 'auto'],
                            content: res,
                            end: function () {
                                logining = false;
                                if (deferred.state() === 'pending') {
                                    window.location.href = '/index.html'
                                }
                            },
                            success: function (layero, index) {
                                var vm = new Model(self, layero, index);
                                ko.applyBindings(vm, layero[0]);
                            }
                        })
                    })
                }
            }
        }

        //
        deferred.done(callback);
    };
    //
}

//
function Model(context, layero, index) {
    var self = this;
    //
    this.close = function () {
        layer.close(index);
    }
    // 会员
    this.member = ko.mapping.fromJS({"phone": localStorage.getItem('phone') || "", "pwd": ""});
    // 记住密码
    this.rememberMe = ko.observable(false);
    // 登录
    this.login = function () {
        // 验证
        validator(layero).done(function () {
            //
            $.post({
                url: hostsetter('members/login'),
                type: 'post',
                data: ko.mapping.toJS(self.member),
                loadingTip: '努力登录中...'
            }).success(function (res, xhr) {
                if (res.success === true) {
                    layer.close(index);
                    if (self.rememberMe()) {
                        localStorage.setItem('phone', self.member.phone());
                    }
                    context.resolveForcefully(res.data);
                } else {
                    layer.msg(res.errorMsg)
                }
            })
        })
        //
    }
}

//
//
module.exports = new Context();



/*****************
 ** WEBPACK FOOTER
 ** ./controller/context.js
 ** module id = 105
 ** module chunks = 2 3 5 6 7 8 9 12 13 14 15 16 17 18
 **/